@if (addressBookData.length > 0) {
  <div class="address-book-container">
    <div class="address-book-header">
      {{ CONSTANTS.ADDRESS_BOOK_RESULTS }} ({{ addressBookData.length }})
    </div>

    <!-- Fixed Header -->
    <ion-grid class="table-header">
      <ion-row>
        <ion-col size="4">{{ CONSTANTS.NAME }}</ion-col>
        <ion-col size="2">{{ CONSTANTS.CITY }}</ion-col>
        <ion-col size="2">{{ CONSTANTS.STATE }}</ion-col>
        <ion-col size="2">{{ CONSTANTS.POSTAL }}</ion-col>
        <ion-col size="2">{{ CONSTANTS.COUNTRY }}</ion-col>
      </ion-row>
    </ion-grid>

    <!-- Scrollable Table Body -->
    <div class="table-body-scroll">
      <ion-grid>
        <ion-row *ngFor="let entry of addressBookData" class="table-row">
          <ion-col
            size="4"
            class="consignee-field"
            (click)="onRowClick(entry)"
            >{{ entry.customername }}</ion-col
          >
          <ion-col size="2">{{ entry.pd2 }}</ion-col>
          <ion-col size="2">{{ entry.pd1 }}</ion-col>
          <ion-col size="2">{{ entry.postalcode }}</ion-col>
          <ion-col size="2">{{ entry.isocode }}</ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
} @else {
  <div>
    {{ CONSTANTS.NO_ADDRESS_FOUND }}
  </div>
}
